import { Grid, Typography, Tooltip, IconButton, Stack } from '@mui/material'
import { ClassNameMap, withStyles } from '@mui/styles'
import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../redux/store'
import InfoIcon from '@mui/icons-material/Info'
import stylesheet from '../detail-container.stylesheet'
import moment from 'moment'
interface IProps {
  item: any
  compKey: string
  classes: ClassNameMap
}

const RationaleComponent: React.FC<IProps> = ({ item, compKey, classes }) => {
  const program_conditions = useSelector(
    (state: RootState) => state.patientDetail.patientDetail.conditions.program_conditions
  )
  const getSourceAttr = (currItem: any) => {
    const srcVal = (currItem && item?.c_rationale?.source_attributes[currItem]) || ''
    return srcVal?.name ? <Tooltip
      title={<Typography onClick={() => window.open(`${srcVal?.url}`, "_blank")}
        component="span"
        className={[classes.evalBoxVal, classes.srcAttributes].join(' ')}
        variant="subtitle2">
        {srcVal?.name}
      </Typography>}
      placement="bottom-start"
      disableFocusListener
    >
      <IconButton size='small' className={classes.infoIcon}>
        <InfoIcon className={classes.infoIconFont} /> </IconButton>
    </Tooltip>
      : ''
  }

  const getInclusiveCriteria = (title: any, criteriaObj: any, criteria: boolean, isExCriteria: boolean) => {
    let status = title === 'Inclusion criteria'
      ? 'Fail'
      : (title === 'Exclusion criteria' && isExCriteria)
        ? 'Fail' : 'Pass'

    const cList = criteriaObj && Object.keys(criteriaObj)?.map((m: any, key: any) => {
      const { value, dependents, dependent_has_override } = criteriaObj[m]
      if (title === 'Exclusion criteria' && value === criteria && status === 'Pass')
        status = 'Fail'
      else if (title === 'Inclusion criteria' && value === criteria && status === 'Fail')
        status = 'Pass'

      const highlightCriteria = (dKey: string) => {
        return <Typography component={'span'} className={classes.evalBoxLabel} variant="body2"
          color={dependent_has_override
            ? dKey === null ? '#bf65e8 !important' : '#256aef !important'
            : 'inherit'}
        >
          {dKey === null ? JSON.stringify(dKey) : dKey}
        </Typography>
      }

      const depenList = dependents && Object.keys(dependents)?.map((key: any, index: any) =>
        <Typography component={'span'} className={classes.evalBoxLabel} variant="body2">
          <Typography component={'span'} className={classes.evalBoxLabel} variant="body2">
            {key} {dependents && ` : `}
          </Typography>
          {highlightCriteria(dependents[key])}
          {(index + 1) < Object.keys(dependents).length &&
            <Typography component={'span'} className={classes.evalBoxLabel} variant="body2" color="textSecondary">{`,`}&nbsp;</Typography>
          }
        </Typography>
      )

      return <Grid item key={`${key}-${m}}`}>
        <Stack direction={'row'} sx={{ width: 'max-content', backgroundColor: dependent_has_override ? '#ffff00cc !important' : 'inherit' }}>
          <Typography className={classes.evalBoxLabel} variant="body2" color="textSecondary">
            {m}
          </Typography>
          <Typography className={classes.evalBoxLabel} variant="body2" color="textSecondary">:&nbsp;</Typography>
          <Typography className={classes.evalBoxLabel} variant="body2"
            color={(value === criteria)
              ? `${title === 'Exclusion criteria' ? 'red' : 'green'} !important`
              : 'textSecondary'}>
            {JSON.stringify(value)}
          </Typography>
          {depenList?.length > 0 &&
            <Typography className={classes.evalBoxLabel} variant="body2" color="textSecondary">
              &nbsp;[{depenList}]
            </Typography>
          }
        </Stack>
      </Grid>
    })

    return <Grid item className={classes.fullWidth}>
      <Grid container direction="column">
        <Grid item>
          <Stack direction={'row'} spacing={0.4}>
            <Typography className={classes.evalBoxVal}>
              {title}
            </Typography>
            {Object.keys(cList)?.length > 0 &&
              <Typography className={classes.evalBoxVal} variant="body2" color={`${status === 'Fail' ? 'red' : 'green'} !important`}> {status} </Typography>
            }
          </Stack>
        </Grid>
        <Grid item>
          <Grid container direction="column" className={classes.evalSubBox}>
            {cList}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  }

  const getLabel = (val: any) => <Typography className={classes.evalBoxVal}>{val}</Typography>

  return (
    <Grid className={item.isProviderRecomm ? classes.evalProviderContent : classes.evalContent} container spacing={1}>
      {!item?.isProviderRecomm &&
        <Grid item className={classes.fullWidth}>
          <Grid container direction="row" className={classes.evalToxCard}>
            <Grid item>{getLabel('Rationale creation date')}</Grid>
            <Grid item>
              <Typography className={classes.toxicityEvalBoxVal}>
                {item?.recommendation_date && moment.unix(item?.recommendation_date).format('MMM DD, YYYY hh:mm a')}
              </Typography>
            </Grid>
          </Grid>
          <Grid container direction="column">
            <Grid item>{getLabel('Relevant conditions')}</Grid>
            <Grid item>
              <Grid container direction="column" className={classes.evalSubBox}>
                {item.c_rationale?.conditions && item.c_rationale?.conditions?.map((m: any) =>
                  <Grid item key={`relCon-${m}`}>
                    <Typography key={m} className={classes.evalBoxLabel} variant="body2" color="textSecondary">
                      {`${program_conditions?.find((f: any) => f.id === m)?.display_name || ''}`}
                      {getSourceAttr(m)}
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      }
      {!item?.isProviderRecomm &&
        <Grid item className={classes.fullWidth}>
          {getInclusiveCriteria('Inclusion criteria', item?.c_rationale?.incl_criteria, true, false)}
        </Grid>
      }
      <Grid item className={classes.fullWidth}>
        {getInclusiveCriteria(
          'Exclusion criteria',
          item?.c_rationale?.excl_criteria,
          true,
          (item?.c_rationale?.meets_exclusion || Boolean(item?.c_rationale?.exclusion_reason)))
        }
      </Grid>
      <Grid item className={classes.fullWidth}>
        <Stack direction={'row'} spacing={0.4}>
          <Typography className={classes.evalBoxVal}>{`Exclusion reason`}</Typography>
          <Typography className={classes.evalBoxVal} variant="body2"
            color={item?.c_rationale?.exclusion_reason && item?.c_rationale?.exclusion_reason !== '' ? 'red !important' : 'textSecondary'}
          >
            {item?.c_rationale?.exclusion_reason || ''}
          </Typography>
        </Stack>
      </Grid>
      {!item?.isProviderRecomm &&
        <Grid item className={classes.fullWidth}>
          {getInclusiveCriteria('Substitute exclusion criteria', item?.c_rationale?.sub_excl_criteria, true, true)}
        </Grid>
      }
      {!item?.isProviderRecomm &&
        <Grid item className={classes.fullWidth}>
          {getInclusiveCriteria('Substitute inclusion criteria', item?.c_rationale?.sub_incl_criteria, false, false)}
        </Grid>
      }
      <Grid item className={classes.fullWidth}>
        {getInclusiveCriteria('Taking med exclusion criteria', item?.c_rationale?.taking_med_excl_criteria, true, true)}
      </Grid>
    </Grid>
  )
}

export default withStyles(stylesheet)(RationaleComponent)
